/** 宽于此值为 PC 布局（与原先 H5 遮罩断点 768 一致） */
export const DESKTOP_BREAKPOINT = 768;

export function isDesktopWidth(width) {
  return width != null && width > DESKTOP_BREAKPOINT;
}
